// extracted by mini-css-extract-plugin
export default {"wrapper":"DeleteUserWarningModal_wrapper__a+WkD"};